export default "__VITE_ASSET__09316c0c__"